function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { shouldSeeProductsPricingPage, shouldSeeV10PricingVersion } from "services/ab-tests/monetization-ab-tests-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import DefaultProps from "./default-props";
import ProductPriceAndFeaturesCards from "./product-prices-and-features-cards/product-prices-and-features-cards-component";
import PriceCardsComponent from "./components/price-cards/price-cards-component";
import { setCookie } from "/services/cookies-service";
import { SERVICE_PRODUCT_ID } from "constants/products";
class PricesAndFeaturesCardsPricingComponent extends PureComponent {
    componentDidUpdate() {
        this.checkIfShouldSeeProductsFeaturesTable();
    }
    checkIfShouldSeeProductsFeaturesTable() {
        const { productName, abTests, clusterId, hasStudentPlan, cookies, forcePricing, cloudfrontViewerCountry, isClusterMiniSitePage } = this.props;
        this.shouldSeeProductsFeaturesTable = productName && (isClusterMiniSitePage || shouldSeeProductsPricingPage({
            abTests,
            clusterId,
            hasStudentPlan,
            cookies,
            forcePricing,
            cloudfrontViewerCountry
        }));
        // only used to emit bigbrain event
        shouldSeeV10PricingVersion({
            cookies,
            forcePricing,
            abTests
        });
    }
    render() {
        const { isHomepagePricing } = this.props;
        // rendering another component because we need access to ab tests as well.
        if (this.shouldSeeProductsFeaturesTable || isHomepagePricing) {
            return /*#__PURE__*/ _jsx(ProductPriceAndFeaturesCards, _object_spread({}, this.props));
        }
        return /*#__PURE__*/ _jsx(PriceCardsComponent, _object_spread({}, this.props));
    }
    constructor(props){
        super(props);
        this.checkIfShouldSeeProductsFeaturesTable();
    }
}
export default withAbTests(withGenericConfig(PricesAndFeaturesCardsPricingComponent));
PricesAndFeaturesCardsPricingComponent.defaultProps = DefaultProps;
